import Vue from "vue";
import VueI18n, { TranslateResult } from "vue-i18n";
import messages from "@/i18n/messages";

Vue.use(VueI18n);

const language =
  (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language;
const defaultLocale = "ja";
const languageLocaleMap: Record<string, string> = {
  ja: "ja",
  en: "en",
  "en-US": "en",
  "zh-TW": "zh-TW",
};
function getLocaleFromLanguage(language: string): string {
  return languageLocaleMap[language] || defaultLocale;
};
const locale = getLocaleFromLanguage(language);

const i18n = new VueI18n({
  locale: locale,
  messages: messages,
});

const translate = (key: string): TranslateResult => {
  if (!key) {
    return "";
  }
  return i18n.t(key);
};
export { i18n, translate };
